import { initSentry } from '@referee/error-handling';
import { getPlatform, isNativePlatform } from './utils/platform';

/**
 * Chooses the native (Capacitor) or web Sentry init path (Phase 82 D-01/D-02).
 *
 * The dynamic import of ./native-sentry keeps @sentry/capacitor out of the
 * web entry chunk, following the existing StatusBar `isNativePlatform()`
 * precedent in main.tsx. If the native module fails to load or init, this
 * falls back to the plain web init (still tagged with the real platform) so
 * JS errors are still captured (T-82-03).
 */
export async function setupSentry(): Promise<void> {
  if (isNativePlatform()) {
    try {
      const { initNativeSentry } = await import('./native-sentry');
      initNativeSentry(getPlatform());
    } catch {
      initSentry({ initialScope: { tags: { platform: getPlatform() } } });
    }
    return;
  }

  initSentry({ initialScope: { tags: { platform: 'web' } } });
}
